import {
    Car,
    Bike,
    Truck,
    Shield,
    Disc,
    BatteryCharging,
    Fuel,
    Siren,
    ArrowUpRight,
} from "lucide-react";
import { SERVICES, buildWhatsAppLink, IMAGES } from "../../lib/constants";

const ICONS = {
    car: Car,
    bike: Bike,
    truck: Truck,
    shield: Shield,
    disc: Disc,
    battery: BatteryCharging,
    fuel: Fuel,
    siren: Siren,
};

export const Services = () => {
    return (
        <section
            id="servicos"
            data-testid="services-section"
            className="relative bg-white py-20 md:py-28"
        >
            <div className="container mx-auto px-4 md:px-8">
                <div className="max-w-3xl mb-12 md:mb-16">
                    <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                        · Nossos serviços ·
                    </span>
                    <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight text-black mt-3 leading-[0.95]">
                        Socorro completo,
                        <br />
                        <span className="text-[#f45100]">na hora</span> que você
                        precisa.
                    </h2>
                    <p className="mt-5 text-base md:text-lg text-gray-600 max-w-2xl">
                        Da troca de um pneu na rua ao reboque de veículos
                        blindados — a RCM Guincho Express tem a estrutura, o
                        equipamento e a equipe certa para cada emergência.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                    {SERVICES.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        const isFeatured = i === 3 || i === 7;
                        return (
                            <a
                                key={s.id}
                                href={buildWhatsAppLink(s.msg)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`service-card-${s.id}`}
                                className={`group relative overflow-hidden p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 ${
                                    isFeatured
                                        ? "bg-[#0a0a0a] text-white hover:bg-[#f45100]"
                                        : "bg-[#f8f9fa] text-black hover:bg-black hover:text-white border border-gray-200"
                                }`}
                            >
                                <div className="flex items-start justify-between mb-6">
                                    <div
                                        className={`w-14 h-14 flex items-center justify-center transition-colors duration-300 ${
                                            isFeatured
                                                ? "bg-[#f45100] group-hover:bg-white group-hover:text-[#f45100]"
                                                : "bg-[#f45100] text-white"
                                        }`}
                                    >
                                        <Icon size={26} strokeWidth={2.2} />
                                    </div>
                                    <ArrowUpRight
                                        size={22}
                                        className="opacity-40 group-hover:opacity-100 group-hover:rotate-12 transition-all"
                                    />
                                </div>

                                <h3 className="font-display text-xl md:text-2xl font-extrabold uppercase tracking-tight leading-tight">
                                    {s.title}
                                </h3>
                                <p
                                    className={`mt-3 text-sm leading-relaxed ${
                                        isFeatured
                                            ? "text-white/70 group-hover:text-white/90"
                                            : "text-gray-600 group-hover:text-white/80"
                                    }`}
                                >
                                    {s.desc}
                                </p>

                                <div className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em]">
                                    <span className="w-6 h-px bg-current" />
                                    Solicitar no WhatsApp
                                </div>
                            </a>
                        );
                    })}
                </div>

                {/* Highlight Banner */}
                <div className="mt-12 md:mt-16 relative overflow-hidden bg-[#0a0a0a] text-white">
                    <div className="absolute inset-0 opacity-30">
                        <img
                            src={IMAGES.serviceNight}
                            alt="Guincho RCM atendendo durante a madrugada em Praia Grande"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="relative z-10 p-8 md:p-12 lg:p-16 grid md:grid-cols-2 gap-8 items-center">
                        <div>
                            <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                                · Madrugada · Feriado · Domingo ·
                            </span>
                            <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3">
                                Quando o problema não tem hora,{" "}
                                <span className="text-[#f45100]">
                                    nós também não.
                                </span>
                            </h3>
                            <p className="mt-4 text-white/75 max-w-xl">
                                Nossa frota está em operação contínua. Não
                                importa se é 3h da manhã ou feriado — o
                                atendimento sai imediatamente.
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row md:justify-end gap-3">
                            <a
                                href={buildWhatsAppLink()}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="services-banner-whatsapp-btn"
                                className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#25D366] hover:bg-[#1ebd5c] rounded-xl font-bold transition-all hover:scale-105"
                            >
                                Chamar no WhatsApp
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
